module.exports = __webpack_public_path__ + "fonts/EMprint-RegularItalic.6db90288.ttf";